import PropTypes from 'prop-types';

import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const getColor = (color, theme) => {
  let styling;
  switch (color) {
    case 'neutral':
      styling = theme.palette.common.neutral;
      break;
    case 'primary':
      styling = theme.palette.primary.main;
      break;
    case 'info':
      styling = theme.palette.info.main;
      break;
    case 'success':
      styling = theme.palette.success.main;
      break;
    case 'warning':
      styling = theme.palette.warning.main;
      break;
    case 'danger':
      styling = theme.palette.danger.main;
      break;
    case 'pending':
      styling = theme.palette.pending.main;
      break;
    default:
      styling = theme.palette.common.neutral;
  }
  return styling;
};

const getSize = (size, theme) => {
  let height;
  let width;
  switch (size) {
    case 'sm':
      height = theme.spacing(1);
      width = theme.spacing(1);
      break;
    case 'md':
      height = theme.spacing(2);
      width = theme.spacing(2);
      break;
    case 'lg':
      height = theme.spacing(3);
      width = theme.spacing(3);
      break;
    default:
      height = theme.spacing(2);
      width = theme.spacing(2);
  }
  return { height, width };
};

const Status = props => {
  const { className, size, color, sx, ...rest } = props;
  const theme = useTheme();
  const stylingColor = getColor(color, theme);
  const { height, width } = getSize(size, theme);

  return (
    <Box
      component="span"
      {...rest}
      style={{
        display: 'inline-block',
        borderRadius: '50%',
        flexGrow: 0,
        flexShrink: 0,
        backgroundColor: stylingColor,
        height,
        width,
      }}
      sx={sx}
      className={className}
    />
  );
};

Status.propTypes = {
  color: PropTypes.oneOf(['neutral', 'primary', 'info', 'success', 'warning', 'danger', 'pending']),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.func]),
};

Status.defaultProps = {
  color: 'default',
  size: 'md',
  sx: undefined,
};

export default Status;
